import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { ToastHost } from './components/ToastHost';
import { AuthProvider } from './lib/auth-context';
import { queryClient } from './lib/query';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root bulunamadı');

createRoot(root).render(
  // StrictMode korunuyor: çift effect çalıştırması, temizlenmemiş abonelikleri
  // ve iki kez tetiklenen isteklerini geliştirmede yakalar.
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
      <ToastHost />
    </QueryClientProvider>
  </StrictMode>,
);
